const getUser = () => {
  const user = localStorage.getItem('USER');
  if (user) {
    return JSON.parse(user);
  }
  return null;
};

// IAP tester (Play Store policy): saat true, user hanya boleh akses dashboard.
// Field is_tester disuplai backend di /api/auth/user/me dan disimpan AuthService.me().
const isTester = () => {
  const user = getUser();
  return !!user?.is_tester;
  // return true;
};

export default getUser;
export { isTester };